module.exports = __webpack_public_path__ + "img/dropsLive_320.87d17344.png";